import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Spin, Modal } from "antd";
import { Suspense } from "react";
import $style from "./index.css";
/**
 * 加载资源时候 显示的等待界面
 * @user: antes
 * @emial: tangzhlyd@gmail.com
 * @data: 2020/12/15 下午1:07
 */ export function Loading() {
    return /*#__PURE__*/ _jsx("div", {
        className: $style.rantion_loading,
        style: {
            paddingTop: "20vh",
            minHeight: "80vh"
        },
        children: /*#__PURE__*/ _jsx(Spin, {
            size: "large"
        })
    });
}
export function SuspenseLoading(param) {
    let { children } = param;
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: /*#__PURE__*/ _jsx(Loading, {}),
        children: children
    });
}
/**
 * 加载失败
 * @param props
 * @constructor
 */ export function LoadingError() {
    function reload() {
        localStorage.clear();
        location.reload();
    }
    function showConfirm() {
        Modal.confirm({
            title: "sorry",
            content: "程序猿认识到他的错误了, 确定将清理缓存，重新登录",
            onOk () {
                reload();
            }
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: $style.rantion_loading,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: $style.page404,
                children: "500"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: $style.subtitle,
                children: "很抱歉，程序出现异常了。"
            }),
            /*#__PURE__*/ _jsx("br", {}),
            /*#__PURE__*/ _jsx(Button, {
                type: "link",
                onClick: reload,
                children: "注销登录，重新加载"
            }),
            "or",
            /*#__PURE__*/ _jsx(Button, {
                type: "link",
                onClick: showConfirm,
                children: "狠狠的批斗程序猿"
            })
        ]
    });
}
